export var Tooltips = {
    Base: {
        fontWeight: 'medium',
        fontSize: 'sm',
        p: 3,
        rounded: 'md'
    },
    Primary: {
        bg: 'blue.500',
        color: 'white',
        fontWeight: 'medium',
        fontSize: 'sm',
        p: 3,
        rounded: 'md'
    }
};
